module.exports = __webpack_public_path__ + "img/b5.272e9084.png";